import { render, staticRenderFns } from "./u-dialog-flat-tile.vue?vue&type=template&id=3cdad768&scoped=true"
import script from "./u-dialog-flat-tile.vue?vue&type=script&lang=js"
export * from "./u-dialog-flat-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdad768",
  null
  
)

export default component.exports